import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ActaWithFirma,
  cleanFile,
  cleanMsg,
  cleanState,
  getFirmas,
  useActas,
} from '../../../../appStore/actas';
import { useConcurso } from '../../../../providers/ConcursoProvider';
import { ActaFila } from './ActaFila';
import styled from 'styled-components';
import { ROLES } from '../../../../const';
import { FirmaBajoConformidad } from './FirmaBajoConformidad';
import { SuccessErrorDlg } from '../../../CompUtils/SuccessErrorDlg';
import { FileModal } from '../../../CompUtils/FileModal';
import { CommonRoot } from '../../../CompUtils/CommonRoot';
import { AdjuntarNuevaActa } from './AdjuntarNuevaActa';
import { PuestosTable } from '../TramitarConcursos/Commons/PuestosTable/PuestosTable';
import FullLoading from '../../../CompUtils/FullLoading';
import { Button } from 'react-bootstrap';
import AlertDialog from '../../../CompUtils/AlertDialog';

const HorizontalDiv = styled.div`
  display: flex;
  margin: 15px 0px;
`;

export type ActaProps = {
  adjuntoCerrado: boolean;
  descripcion: string;
  fechaCreacion: string;
  firmaCerrada: boolean;
  firmada: boolean;
  firmas: any;
  idActaConcurso: number;
  idLLamadoConcurso: number;
  idUsuarioComiteCargador: number;
  pathDocumento: string;
  titulo: string;
  vistaPublica: boolean;
};

type Props = { publicado: boolean };
const ListadoActas = (props: Props) => {
  const { publicado } = props;
  const dispatch = useDispatch();
  const firmarRef = useRef<ActaWithFirma | null>(null);
  const [firmaPopup, setFirmaPopup] = useState(false);
  const { user } = useSelector((state: any) => state.common);
  const { idLlamadoConcurso, esCoordinadorConcursal } = useConcurso();
  const { actas, file, loading, error, success } = useActas();

  useEffect(() => {
    dispatch(getFirmas({ idLlamadoConcurso }));
    return () => {
      dispatch(cleanState());
    };
  }, [dispatch, idLlamadoConcurso]);

  return (
    <>
      <CommonRoot>
        <FullLoading show={loading} />
        <h2 className="text-info text-center ">LISTADO DE ACTAS</h2>
        <table className="table">
          <colgroup>
            <col style={{ width: '40%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '20%' }} />
          </colgroup>
          <thead>
            <tr>
              <th>Acta</th>
              <th>Fecha</th>
              <th>Ver</th>
              <th>Acción Requerida</th>
            </tr>
          </thead>
          <tbody>
            {actas?.map((e: any) => (
              <ActaFila
                key={e.idActaConcurso}
                {...e}
                onFirmar={() => {
                  firmarRef.current = e;
                  setFirmaPopup(true);
                }}
              />
            ))}
          </tbody>
        </table>
        {!publicado && user.roles.includes(ROLES.DIRECTOR) && (actas ?? []).length > 0 && (
          <div className="d-flex flex-row-reverse mt-3">
            <Button variant="success">Enviar a legales</Button>
          </div>
        )}
        {esCoordinadorConcursal && <AdjuntarNuevaActa />}
        <FileModal file={file} onClose={() => dispatch(cleanFile())} title="Acta" />
        <AlertDialog
          btns={['close']}
          show={!!firmaPopup && !!firmarRef.current?.idFirmaActa}
          icon="question"
          title="Concursar"
          onClose={() => setFirmaPopup(false)}
          subtitle={
            <FirmaBajoConformidad
              onClose={() => setFirmaPopup(false)}
              idFirmaActa={firmarRef.current?.idFirmaActa ?? 0}
            />
          }
        />
        <SuccessErrorDlg error={error} success={success} onClose={() => dispatch(cleanMsg())} />
      </CommonRoot>
      <PuestosTable idLlamadoConcurso={idLlamadoConcurso} />
    </>
  );
};

export default ListadoActas;
